import { useState } from "react";
import { Button, Modal, Nav, NavDropdown } from "react-bootstrap";
import { ItemForm } from "./ItemForm";

export const CreateItemButton = () => {
    const [open, setOpen] = useState(false)
  return <>
    <Button onClick={() => setOpen(true)}>New Item</Button>
    <Modal show={open} onHide={() => setOpen(false)}>
        <ItemForm onClose={() => setOpen(false)}/>
    </Modal>
  </>
}